// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEffect } from "effector";
import "whatwg-fetch";
import configuration from "../../utils/Config";
import { TemplateDTO } from "../../utils/htmlTemplate/dto/template.dto";
import { restListHandler } from "../../utils/rest/RestClient";

const baseUrl = configuration.backendBaseUrl;
const newsUrl = baseUrl + "/templates";

export const requestGetTemplates = createEffect({
  handler: restListHandler<TemplateDTO>(newsUrl)
});
